import React, { useEffect, useState } from "react";
import { CategoryService, SubCategoryService } from "../../Services";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit, MdOutlineDeleteForever } from "react-icons/md";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import { AddSubCategory } from "./AddSubCategory";
import ReactPaginate from "react-paginate";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const SubCategoryList = () => {
  const [category, setCategory] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const getDetail = async () => {
    setLoader(true);
    let param = { ...pagination, page: currentPage };
    await SubCategoryService.getSubCategory(param).then((res) => {
      setLoader(false);
      setPagination({ ...pagination, ...res.pagination });
      setCategory(res.data);
    });
  };

  const handleDelete = async (id) => {
    let obj = { id: deleteId };
    await SubCategoryService.deleteCategory(obj)
      .then((res) => {
        if (res.status === true) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        getDetail();
        setDeleteModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenEdit = (item) => {
    setEditId(item._id);
    setSubcategory(item.subcategory_name);
    setEditModal(true);
  };

  const handleEdit = async (e) => {
    const obj = {
      id: editId,
      subcategory_name: subcategory,
    };
    await SubCategoryService.updateCategory(obj)
      .then((res) => {
        if (res?.status === true) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        getDetail();
        setEditModal(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDeleteModal = async (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleInput = (e) => {
    setSubcategory(e.target.value);
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getDetail();
  }, [currentPage]);

  return (
    <div style={{ width: "50%" }}>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
          {
            (CheckAccess(62,"add") ||  user_type === "SUPERADMIN" )&& 
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => setAddModal(true)}
            >
              Add Sub Category
            </Button>
          }
          </div>

          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S no.</th>
                  {/* {/ <th>Category Name</th> /} */}
                  <th>Sub category Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {category?.length > 0 &&
                  category?.map((item, key) => (
                    <tr key={key}>
                      <td className="text-body fw-bold">{(pagination.page - 1) * pagination.limit + (key + 1)}</td>
                      <td>{item?.subcategory_name || ""}</td>

                      <td>
                      {
                         (CheckAccess(62,"edit") || user_type === "SUPERADMIN") && 
                        <MdEdit
                          className="pointer"
                          onClick={() => handleOpenEdit(item)}
                          style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                        />
                      }

                      {
                        (CheckAccess(62,"delete") ||  user_type === "SUPERADMIN") && 
                        <MdOutlineDeleteForever
                          className="pointer"
                          onClick={() => handleDeleteModal(item._id)}
                          style={{ fontSize: "22px", color: "red" }}
                        />
                      }
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="text-center">
              {(loader && <Spinner animation="grow" size="sm" />) || ""}
            </div>
            {category?.length <= 0 && !loader && (
              <div className="text-center w-100 bg-warning my-5">
                <h6 className="py-2"> list not available </h6>
                {/* {/ <Spinner animation="grow" size="sm" /> /} */}
              </div>
            )}

            {category &&
              category.length > 0 &&
              pagination.total_record > pagination.limit && (
                <ReactPaginate
                  previousLabel={
                    <img
                      src="assets/images/prev.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  forcePage={currentPage - 1}
                  nextLabel={
                    <img
                      src="assets/images/next.svg"
                      height={15}
                      alt="not found"
                    />
                  }
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    pagination.total_record / pagination.limit
                  )}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(e) => onPageChangeEvent(e)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              )}
          </div>

          {/* {/ Add Modal /} */}

          <Modal
            show={addModal}
            onHide={() => setAddModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Sub Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddSubCategory
                category={category}
                setAddModal={setAddModal}
                getDetail={getDetail}
              />
            </Modal.Body>
          </Modal>

          {/* {/ Edit Modal /} */}

          <Modal
            show={editModal}
            onHide={() => setEditModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Sub Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3 col-12">
                {/* {/ <label className="form-label mb-1">Category Name</label> /} */}
                <input
                  type="text"
                  className="form-control"
                  name="subcategory_name"
                  value={subcategory}
                  placeholder="Name"
                  onChange={(e) => handleInput(e)}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setEditModal(false)}>
                No
              </Button>
              <Button variant="danger" onClick={handleEdit}>
                {/* {/ {(loader && <Spinner animation="grow" size="sm" />) || " /} */}
                Yes
                {/* {/ "} /} */}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* {/ Delete Modal /} */}

          <Modal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Sub Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure want to delete the category?</Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal(false)}>
                No
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Yes"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
